import { useEffect, useState } from "react";
import { DisplayMode } from "./DisplayMode";
import { getDisplayModeForWidth } from "./getDisplayModeForWidth";
import { registerListener } from "./registerListener";

/**
 * Provides access to the current responsive display mode.
 * @returns The current responsive display mode.
 */
export function useResponsiveDisplayMode(): DisplayMode {

  const [currentMode, setCurrentMode] = useState<DisplayMode>(getDisplayModeForWidth(window.innerWidth));

  useEffect(() => {
    return registerListener((displayMode) => {
      setCurrentMode(displayMode);
    });
  }, []);

  return currentMode;
}
